import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import CommentIcon from '@mui/icons-material/Comment';
import useMediaQuery from '@mui/material/useMediaQuery';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AssistantIcon from '@mui/icons-material/Assistant';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Outlet, useLocation, Link, useNavigate } from 'react-router-dom'; // Import useLocation
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded';
import { useCommon } from '../context/CommonContext';
import { get, patch, post } from '../services/api-services';
import Logout from '../dialogs/Logout';
import ProfileDialog from '../dialogs/ProfileDialog';
import Badge from '@mui/material/Badge';
// import { userAuthState } from '../services/RecoilService';
const drawerWidth = 240;

const Main = styled('main')(({ theme, open, isSmallScreen }) => ({
    flexGrow: 1,
    padding: 0, // Set padding to 0 for flush design; individual components handle internal padding
    marginLeft: open && !isSmallScreen ? `${drawerWidth}px` : 0,
    transition: theme.transitions.create(['margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#eff1f5', // Ensure consistent background for the main content area
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export const Index = () => {
    const theme = useTheme();
    // const [authState, setAuthState] = useRecoilState(AuthState);
    const [open, setOpen] = useState(true);
    const { setSnackbar, currentUser, setCurrentUser } = useCommon();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation(); // Hook to get current location
    const path = location.pathname.split("/");
    const navigate = useNavigate();
    const toggleDrawer = () => setOpen(!open);
    const [anchorEl, setAnchorEl] = useState(null);
    const [unreadMsgCount, setUnreadMsgCount] = useState(0);
    const [openProfile, setOpenProfile] = useState(false);
    const [openLogout, setOpenLogout] = useState(false);
    const [profile, setProfile] = useState({ name: '', email: '', password: '' });
    const openMenu = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const drawerList = [
        {
            route: "admin/cases",
            title: "Cases",
            icon: <AccountCircleIcon />
        },
        {
            route: "admin/task",
            title: "Task",
            icon: <AssignmentIcon />
        },
        {
            route: "admin/sales",
            title: "Sales",
            icon: <AttachMoneyIcon />
        },
        {
            route: "admin/support",
            title: "Support",
            icon: <CommentIcon />
        },
        {
            route: "admin/programs",
            title: "Program",
            icon: <AssistantIcon />
        },
        {
            route: "admin/settings",
            title: "Settings",
            icon: <SettingsIcon />
        },


    ]
    const onGetSupportUnread = async () => {
        const res = await get('/SupportTopics?filter={"include" : [{"relation" : "chats", "scope" : {"order": "createdAt DESC"}}, {"relation" : "customer" }], "order": "lastCustomerMsgOn DESC" }');

        if (res && res.data) {
            const unreadMsgCount = res.data.reduce((count, item) => {
                const unreadChats = item.chats?.filter(
                    (chat) => chat.status === "unread" && chat.sendBy === "customer"
                );
                return count + (unreadChats?.length || 0);
            }, 0);
            setUnreadMsgCount(unreadMsgCount);
        }
    }

    const onEditProfile = async () => {
        const res = await get(`/Customers/${currentUser?.userId}`);
        if (res?.statusCode === 200) {
            setProfile({ name: res?.data?.name, email: res?.data?.email })
        }
        setOpenProfile(true);
        handleClose();

    }
    const onClose = async () => {
        setOpenProfile(false);
        setProfile({ name: '', email: '', password: '' });
    }
    const onEditSubmit = async () => {
        let finalObject = { name: profile?.name, email: profile?.email }
        if (profile?.password) { finalObject.password = profile?.password }
        const res = await patch(`/Customers/${currentUser?.userId}`, finalObject);
        if (res?.statusCode === 200) {
            setSnackbar({
                openSnackbar: true,
                message: 'User updated successfully',
                severity: 'success'
            })
            onClose();
        }

    }
    const onLogOut = async () => {
        await post('/Customers/logout')
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('role');

        // location.reload();
        setOpenLogout(true);
        navigate('/')
    }
    const onCloseLogout = async () => {
        setOpenLogout(false);
    }
    useEffect(() => {
        const user = {
            accessToken: localStorage.getItem('accessToken'),
            userId: localStorage.getItem('userId'),
            userName: localStorage.getItem('userName'),
            role: localStorage.getItem('role'),
        };
        setCurrentUser(user);
    }, [setCurrentUser])

    useEffect(() => {
        onGetSupportUnread();
    }, [])

    useEffect(() => {
        const root = path[2];
        if (root) {
            sessionStorage.setItem(`last_path_${root}`, location.pathname + location.search);
        }
    }, [location.pathname, location.search, path]);

    const handleNavigation = (route) => {
        const routeRoot = route.split('/')[1]; // e.g., 'cases'
        const currentRoot = path[2]; // e.g., 'cases'
        
        const savedPath = sessionStorage.getItem(`last_path_${routeRoot}`);
        
        if (currentRoot === routeRoot) {
            // If already on this section, reset to the top level
            navigate(`/${route}`);
        } else if (savedPath) {
            // Restore previous deep link for this section
            navigate(savedPath, { state: { fromSidebar: true } });
        } else {
            navigate(`/${route}`);
        }

        // Close the drawer automatically on mobile/tablet after navigating
        if (isSmallScreen) {
            setOpen(false);
        }
    };

    return (
        <Box className="flex flex-col flex-1 h-screen">
            <CssBaseline />
            <AppBar position="fixed" elevation={0} sx={{ zIndex: theme.zIndex.drawer + 1, backgroundColor: 'primary' }}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="toggle drawer"
                        onClick={toggleDrawer}
                        edge="start"
                        disableRipple
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        WeightWonder
                    </Typography>
                    <div className='ml-auto'>
                        <Button
                            id="demo-positioned-button"
                            aria-controls={openMenu ? 'demo-positioned-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openMenu ? 'true' : undefined}
                            onClick={handleClick}
                            sx={{ textTransform: 'none', color: 'white' }}
                        >
                            <Typography sx={{
                                display: { xs: 'none', sm: 'block' },
                            }}>  Welcome, {currentUser?.userName}</Typography>
                            <AccountCircleIcon sx={{
                                display: { xs: 'block', sm: 'none' },
                            }} />
                            <i className="material-icons">
                                <KeyboardArrowDownIcon />
                            </i>
                        </Button>
                        <Menu
                            id="demo-positioned-menu"
                            aria-labelledby="demo-positioned-button"
                            anchorEl={anchorEl}
                            open={openMenu}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                        >
                            <MenuItem onClick={() => onEditProfile()}><EditIcon sx={{ marginRight: 2 }} />Edit Profile</MenuItem>
                            <MenuItem onClick={() => { setOpenLogout(true); handleClose(); }}><PowerSettingsNewRoundedIcon sx={{ marginRight: 2 }} /> Sign Out</MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                variant={isSmallScreen ? 'temporary' : 'persistent'}
                anchor="left"
                open={open}
                onClose={toggleDrawer}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
            >
                <DrawerHeader />
                <Divider />
                <List>
                    <ListItemButton onClick={() => handleNavigation('admin/dashboard')}>
                        <ListItemIcon>
                            <DashboardIcon sx={(theme) => ({ 
                                color: 'dashboard' === `${path[2]}` ? (theme.palette.mode === 'dark' ? '#90caf9' : theme.palette.primary.main) : theme?.palette?.icon 
                            })} />
                        </ListItemIcon>
                        <ListItemText primary="Dashboard" sx={{
                            color: (theme) => 'dashboard' === `${path[2]}` ? (theme.palette.mode === 'dark' ? '#90caf9' : theme.palette.primary.main) : 'inherit',
                        }} />
                    </ListItemButton>
                    {(
                        drawerList?.map((data, index) => (
                            <ListItemButton onClick={() => handleNavigation(data.route)} key={index}>
                                <ListItemIcon sx={(theme) => ({ 
                                    color: data.route === `admin/${path[2]}` ? (theme.palette.mode === 'dark' ? '#90caf9' : theme.palette.primary.main) : theme?.palette?.icon 
                                })}>
                                    {data?.icon}
                                </ListItemIcon>
                                <ListItemText primary={data.title} sx={{
                                    color: (theme) => data.route === `admin/${path[2]}` ? (theme.palette.mode === 'dark' ? '#90caf9' : theme.palette.primary.main) : 'inherit',
                                }} />
                                {data.title === 'Support' &&
                                    <Badge badgeContent={unreadMsgCount}
                                        sx={{
                                            borderRadius: '0px !important',
                                            '& .MuiBadge-badge': {
                                                backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#90caf9' : theme.palette.primary.main,
                                                color: (theme) => theme.palette.mode === 'dark' ? '#000' : '#fff',
                                                width: '30px',
                                                marginRight: 2
                                            },
                                        }}
                                    />


                                }
                            </ListItemButton>
                        ))
                    )}
                </List>
            </Drawer>
            <Main open={open} isSmallScreen={isSmallScreen} className='flex flex-col flex-1'>
                <DrawerHeader />
                <div className='flex flex-col flex-1  pt-4 px-6 pb-6  bg-inherit'>
                    <Outlet />
                </div>
            </Main>
            <ProfileDialog
                open={openProfile}
                setOpen={setOpenProfile}
                profile={profile}
                setProfile={setProfile}
                onSubmit={onEditSubmit}
                onClose={onClose}
            />
            <Logout
                open={openLogout}
                setOpen={setOpenLogout}
                setProfile={setProfile}
                onSubmit={onLogOut}
                onClose={onCloseLogout} />
        </Box>
    );
};


